
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'modifiedby-tooltip',
	props: {
		name: String,
		displayDatetime: String,
	},
	setup() {
		return {}
	},
})
